export const BUSINESS_NAME = "Deck Commander";

export const CONTACT_INFO = {
  PHONE: "414.218.4212",
  EMAIL: "mike@deckcommander.us",
  ADDRESS: "",
};

export const SOCIAL_MEDIA = {
  FACEBOOK: "",
  INSTAGRAM: "",
  GOOGLE: "",
};
